import i18n from "@/i18n";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    language: process.env.VUE_APP_I18N_LOCALE || "en",
    sidebar: {
      minimized: false
    },
    pageSize: 10,
    accountId: "",
    pageSizeOptions: [10, 20, 50, 100],
    dateRange: {
      startDate: moment().subtract(12, "hours").toDate(),
      endDate: moment().subtract(12, "hours").toDate()
    },
    daterange: 0,
    currencyList: ["myr", "usd", "vnd"],
    paymentList: ["schedule_1","schedule_2","schedule_3","schedule_4","schedule_5","schedule_6","schedule_7"],
    accessList: ["account", "edit_account", "edit_limit", "forecast", "log", "report", "settlement", "stock"],
    platform: "SPORTSBOOK",
    sportType: "",
    league: {
      id: "",
      name: ""
    },
    match: {
      id: "",
      home: "",
      away: ""
    },
    subMatch: "",
    betType: "",
    fullAmount: true,
    pageDetail: {
      currentPage: 1,
      perPage: 10,
      sortBy: "",
      direction: "DESC"
    },
    betListDetail: {
      full_amount: true,
      bet_type: "",
      match_id: 0,
      is_live: 0,
      home_running_score: 0,
      away_running_score: 0,
      home_away: 0
    }
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    updateSidebarMinimized(state, payload) {
      state.sidebar.minimized = payload;
    },
    updatePageSize(state, payload) {
      state.pageSize = payload;
    },
    updateAccountId(state, payload) {
      state.accountId = payload;
    },
    updateDateRange(state, payload){
      state.dateRange.startDate = payload.startDate;
      state.dateRange.endDate = payload.endDate;
    },
    updatePlatform(state, payload){
      state.platform = payload;
    },
    updateSportType(state, payload){
      state.sportType = payload;
    },
    updateLeagueID(state, payload){
      state.league.id = payload.league_id;
      state.league.name = payload.league_name;
    },
    updateMatchID(state, payload){
      state.match.id = payload.match_id;
      state.match.home = payload.home_team_name;
      state.match.away = payload.away_team_name;
    },
    updateSubMatch(state, payload) {
      state.subMatch = payload;
    },
    updateBetType(state, payload) {
      state.betType = payload;
    },
    updateFullAmount(state, payload) {
      state.fullAmount = payload;
    },
    updatePageDetail(state, payload) {
      state.pageDetail.currentPage = payload.currentPage;
      state.pageDetail.perPage = payload.perPage;
      state.pageDetail.sortBy = payload.sortBy;
      state.pageDetail.direction = payload.direction;
    },
    updateBetListDetail(state, payload) {
      state.betListDetail.full_amount = payload.full_amount;
      state.betListDetail.bet_type = payload.bet_type;
      state.betListDetail.match_id = payload.match_id;
      state.betListDetail.is_live = payload.is_live;
      state.betListDetail.home_running_score = payload.home_running_score;
      state.betListDetail.away_running_score = payload.away_running_score;
      state.betListDetail.home_away = payload.home_away;
    }
  },
  actions: {
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    setSidebarMinimized(context, payload) {
      context.commit("updateSidebarMinimized", payload);
    },
    setPageSize(context, payload) {
      context.commit("updatePageSize", payload);
    },
    setAccountId(context, payload) {
      context.commit("updateAccountId", payload);
    },
    setDateRange(context, payload) {
      context.commit("updateDateRange", payload);
    },
    setPlatform(context, payload) {
      context.commit("updatePlatform", payload);
    },
    setSportType(context, payload) {
      context.commit("updateSportType", payload);
    },
    setLeagueID(context, payload) {
      context.commit("updateLeagueID", payload);
    },
    setMatchID(context, payload) {
      context.commit("updateMatchID", payload);
    },
    setSubMatch(context, payload) {
      context.commit("updateSubMatch", payload);
    },
    setBetType(context, payload) {
      context.commit("updateBetType", payload);
    },
    setFullAmount(context, payload) {
      context.commit("updateFullAmount", payload);
    },
    setPageDetail(context, payload) {
      context.commit("updatePageDetail", payload);
    },
    setBetListDetail(context, payload) {
      context.commit("updateBetListDetail", payload);
    }
  }
};
